import React from 'react';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import SectionHeader from '@monorepo/shared/src/components/layout/SectionHeader';
import HomeGrid from './components/HomeGrid';
import useTrialUserOmitRoutes from 'state/hooks/use-trial-user-omit-routes';

const t = (key) => translate('home', key);

const Home = (): React.ReactElement => {
  const omitRoutes = useTrialUserOmitRoutes();
  return (
    <>
      <SectionHeader title={t('teacherDashboard')} omitRoutes={omitRoutes} />
      <HomeGrid />
    </>
  );
};

export default Home;
